import {defaultConfig as defaultConfigFromDefault} from './defaultData/defaultConfig';

export const defaultConfig = {
    ...defaultConfigFromDefault,
    afterFormSuccessUrl: 'https://www.elements-show.de/heizung/beratungstermin-anfragen?Lead_Ebenen=Heizung&Lead_Source=Heizungskonfigurator'
};

export const ELEMENTS_SHOW_VERSION=true;
export const IMAGE_ROOT_DIRECTORY="/heizungsplanerapp";
export const CONTACT_BY_FACHHANDWERKER_POSSIBLE=false;
export const SHOW_CONTACT_FORM = false;
export const DEBUG_MODE = false;